import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import Text from "components/Text";
import "./PreviewAssociateContract.scss";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import SafeHtml from "components/SafeHtml";
import Card from "components/Card";
import * as moment from "moment";
import { formatCalendarDate } from "utils";
import { v4 as uuidv4 } from "uuid";

function PreviewAssociateContract({
  contractData,
  contractDetails,
  contractFormDisplayData,
  t,
}) {
  const contractFormDisplayDataManipulated = useMemo(() => {
    return contractFormDisplayData.map((res) => ({
      ...res,
      uniqueKey: uuidv4(),
    }));
  }, [contractFormDisplayData]);
  const [expandArray, setExpandArray] = useState([]);
  const toggleItem = (id) => {
    let temp = [...expandArray];
    const index = temp.indexOf(id);
    if (index > -1) {
      temp.splice(index, 1);
    } else {
      temp.push(id);
    }
    setExpandArray(temp);
  };
  const collapseAll = (collpase) => {
    if (collpase) {
      setExpandArray([0, 1, 2, 3, 4]);
    } else {
      setExpandArray([]);
    }
  };
  let serialNo = 0;
  let signatureData = contractFormDisplayDataManipulated.filter(
    (data) =>
      data.inputType == 3 && data.typeOrder != null && data.stepNumber == 6,
  );

  return (
    <div className="container container-smd p-0">
      <Card
        radius="10px"
        marginBottom="10px"
        padding="30px"
        shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
        className={["into-card"]}
      >
        <Text size="14px" color="#102c42" weight="600" marginBottom="0px">
          {contractFormDisplayDataManipulated.map(
            (data) =>
              !data.isMainSection &&
              data.stepNumber == 1 && (
                <span key={data.uniqueKey}>
                  {data.text}
                  <br />
                </span>
              ),
          )}
        </Text>
      </Card>
      <div className={["expand-collapse-wraper"]}>
        <div className="link-btn mr-4" onClick={() => collapseAll(true)}>
          Expand All
        </div>
        <div className="link-btn" onClick={() => collapseAll(false)}>
          Collapse All
        </div>
      </div>
      <Accordion
        className={["contract-detail-accordion associate-accordion"]}
        allowMultipleExpanded
        allowZeroExpanded
      >
        <AccordionItem
          dangerouslySetExpanded={expandArray.includes(0)}
          onClick={() => toggleItem(0)}
        >
          <AccordionItemHeading>
            <AccordionItemButton>{t("contracts.summary")}</AccordionItemButton>
          </AccordionItemHeading>
          {contractData && (
            <AccordionItemPanel className="accordion__panel text-break text-wrap">
              <div className="c-field">
                <label> {t("contracts.dateContract")}</label>
                <p>{moment(contractData.Date).format("DD-MM-YYYY")}</p>
              </div>
              <div className="c-field">
                <label> {t("contracts.businessLegalName")}</label>
                <p>{contractData.BusinessLegalName}</p>
              </div>
              <div className="c-field">
                <label> {t("contracts.position")}</label>
                <p>{contractData.Position}</p>
              </div>
              <div className="c-field">
                <label> {t("form.fields.officeAddress")}</label>
                <p>{contractData.OfficeAddress}</p>
              </div>
              <div className="c-field">
                <label> {t("contracts.lengthEmployment")}</label>
                <p>{contractData.LengthOfEmployment}</p>
              </div>
              <div className="c-field">
                <label> {t("contracts.startWork")}</label>
                <p>
                  {moment(contractData.StartOfWorkDate).format("DD-MM-YYYY")}
                </p>
              </div>
              <div className="c-field">
                <label> {t("contracts.endWork")}</label>
                <p>
                  {contractData.EndOfWorkDate
                    ? moment(contractData.EndOfWorkDate).format("DD-MM-YYYY")
                    : "--"}
                </p>
              </div>
              <div className="c-field">
                <label> {t("contracts.employeeName")}</label>
                <p>{contractData.EmployeeName}</p>
              </div>
              <div className="c-field">
                <label> {t("contracts.employeeAddress")}</label>
                <p>{contractData.EmployeeAddress}</p>
              </div>
              <div className="c-field">
                <label> {t("contracts.salaryFeeWage")}</label>
                <p>{contractData.Salary}</p>
              </div>
              <div className="c-field">
                <label> {t("staff.commission")}</label>
                <p>{contractData.commission || "--"}</p>
              </div>
              <div className="c-field">
                <label> {t("staff.bonus")}</label>
                <p>{contractData.bonus || "--"}</p>
              </div>
            </AccordionItemPanel>
          )}
        </AccordionItem>
        <AccordionItem
          dangerouslySetExpanded={expandArray.includes(1)}
          onClick={() => toggleItem(1)}
        >
          <AccordionItemHeading>
            <AccordionItemButton>
              {t("contracts.ownerAndTheAssociateAgree")}
            </AccordionItemButton>
          </AccordionItemHeading>
          {contractFormDisplayDataManipulated.map(
            (data) =>
              data.isActive &&
              data.isHtmlContent &&
              data.isMainSection &&
              data.stepNumber == 1 && (
                <AccordionItemPanel
                  key={data.uniqueKey}
                  className="accordion__panel text-break text-wrap"
                >
                  <div className="panel-body">
                    <label>
                      {++serialNo}. {data.title}
                    </label>
                    <SafeHtml html={data.text} configType="rich" />
                  </div>
                </AccordionItemPanel>
              ),
          )}
        </AccordionItem>
        <AccordionItem
          dangerouslySetExpanded={expandArray.includes(2)}
          onClick={() => toggleItem(2)}
        >
          <AccordionItemHeading>
            <AccordionItemButton>
              {t("contracts.theOwnerAgree")}
            </AccordionItemButton>
          </AccordionItemHeading>
          {contractFormDisplayDataManipulated.map(
            (data) =>
              data.isActive &&
              data.isHtmlContent &&
              data.isMainSection &&
              data.stepNumber == 2 && (
                <AccordionItemPanel
                  key={data.uniqueKey}
                  className="accordion__panel text-break text-wrap"
                >
                  <div className="panel-body">
                    <label>
                      {++serialNo}. {data.title}
                    </label>
                    <SafeHtml html={data.text} configType="rich" />
                  </div>
                </AccordionItemPanel>
              ),
          )}
        </AccordionItem>
        <AccordionItem
          dangerouslySetExpanded={expandArray.includes(3)}
          onClick={() => toggleItem(3)}
        >
          <AccordionItemHeading>
            <AccordionItemButton>
              {t("contracts.theAssociateAgree")}
            </AccordionItemButton>
          </AccordionItemHeading>
          {contractFormDisplayDataManipulated.map(
            (data) =>
              data.isActive &&
              data.isHtmlContent &&
              data.isMainSection &&
              (data.stepNumber == 3 ||
                data.stepNumber == 4 ||
                data.stepNumber == 5) && (
                <AccordionItemPanel
                  key={data.uniqueKey}
                  className="accordion__panel text-break text-wrap"
                >
                  <div className="panel-body">
                    <label>
                      {++serialNo}. {data.title}
                    </label>
                    <SafeHtml html={data.text} configType="rich" />
                  </div>
                </AccordionItemPanel>
              ),
          )}
        </AccordionItem>
        <AccordionItem
          dangerouslySetExpanded={expandArray.includes(4)}
          onClick={() => toggleItem(4)}
        >
          <AccordionItemHeading>
            <AccordionItemButton>{t("contracts.general")}</AccordionItemButton>
          </AccordionItemHeading>
          {contractFormDisplayDataManipulated.map(
            (data) =>
              data.isActive &&
              data.isHtmlContent &&
              data.isMainSection &&
              data.stepNumber == 6 && (
                <AccordionItemPanel
                  key={data.uniqueKey}
                  className="accordion__panel text-break text-wrap"
                >
                  <div className="panel-body">
                    <label>
                      {++serialNo}. {data.title}
                    </label>
                    <SafeHtml html={data.text} configType="rich" />
                  </div>
                </AccordionItemPanel>
              ),
          )}
        </AccordionItem>
      </Accordion>
      {signatureData.map(
        (data, key) =>
          data.inputType == 3 &&
          data.typeOrder == 1 &&
          data.stepNumber == 6 && (
            <div key={data.uniqueKey}>
              <SafeHtml
                as={Card}
                radius="10px"
                marginBottom="10px"
                padding="30px"
                shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
                className={["review-card-container"]}
                html={data.text}
                configType="rich"
              />
              <Card
                radius="10px"
                marginBottom="10px"
                padding="30px"
                shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
                className={["review-card-container"]}
              >
                <div className="c-field">
                  <label> {signatureData[key + 1].text}</label>
                  <p>{signatureData[key + 2].text} </p>
                </div>
                <div className="sign-img">
                  {signatureData[key + 3].text ? (
                    <img src={signatureData[key + 3].text} alt="signature" />
                  ) : (
                    t("contracts.noSignUploaded")
                  )}
                </div>
                <div className="c-field">
                  {signatureData[key + 4]?.text?.includes("T")
                    ? moment(signatureData[key + 4]?.text).format("DD-MM-YYYY")
                    : moment(signatureData[key + 4]?.text, "DD-MM-YYYY").format(
                        "DD-MM-YYYY",
                      )}
                </div>
                {contractDetails.status === 3 && (
                  <div>
                    <div className="c-field">
                      <label>
                        {" "}
                        {t("contracts.agreeStaffTermsAndConditions")}
                      </label>
                      <p>{contractDetails.staffName} </p>
                    </div>
                    <div className="sign-img">
                      {contractDetails.staffSignature ? (
                        <img
                          src={contractDetails.staffSignature}
                          alt="signature"
                        />
                      ) : (
                        t("contracts.noSignUploaded")
                      )}
                    </div>
                    {moment
                      .utc(contractDetails.staffAcceptedDate)
                      .format("DD-MM-YYYY")}
                  </div>
                )}
              </Card>
            </div>
          ),
      )}
    </div>
  );
}

export default withTranslation()(PreviewAssociateContract);
